import { render, staticRenderFns } from "./default.vue?vue&type=template&id=71d6a00c"
var script = {}
import style0 from "./default.vue?vue&type=style&index=0&id=71d6a00c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports